<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">Sales Enquiry</h1>
        </div>
    </div>
</div>

<div class="container-fluid paddEqual bgGray">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-12">
                <h4 *ngIf="errorMsg" [innerHtml]="errorMsg"></h4>
                <ul class="preferred-choice" *ngIf="enquiryList.length>0">
                    <li *ngFor="let enquiry of enquiryList">
                        <h5>{{enquiry.designation | titlecase}}</h5>
                        <p>{{enquiry.mobile_no}}</p>
                        <a href="mailto:{{enquiry.email_id}}">{{enquiry.email_id}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>